import * as GENERIC from './routes/routes-generic'
import * as HYCS from './routes/routes-hycs'
import * as INVESTMENTS from './routes/routes'
import * as MULTI from './routes/routes-multi'
import * as JOINT from './routes/routes-joint'

export const ALL_ENROLLMENT_ROUTES = {
  GENERIC,
  HYCS,
  INVESTMENTS,
  MULTI,
  JOINT,
  // Other route groups here as needed
}

export * from './routes/routes'
